export const HTTPResponseCodes = {
  FORBIDDEN: 403,
  UNAUTHORIZED: 401,
  BAD_REQUEST: 400
}



// WEBPACK FOOTER //
// ./src/assets/js/Enum/ResponseCodes/HTTPResponseCodes.js